import { FC } from 'react';
import { Theme } from '../types/enums';
import { FAIcon, IconStyle } from '../Icons';
import { PageHeaderProps } from './types/propTypes';
import { PageHeaderType } from './types/enum';
import { AlertContainer } from './AlertContainer/AlertContainer';
import { AlertContainerType } from './AlertContainer/types/enum';
import styles from './AdminPageHeader.module.scss';

export const DashboardPageHeaderMobile: FC<PageHeaderProps> = (props: PageHeaderProps) => {
  const {
    title = '',
    button = [],
    enabled = true,
    zIndex = '0',
    pageHeaderType = PageHeaderType.DEFAULT,
    onBackButtonClick,
    onAlertClick,
    withBackButton = false,
    showAlert = false,
    alertType = AlertContainerType.WARNING,
  } = props;
  button.length = 4;

  return (
    <header
      className={`
      ${styles[pageHeaderType]}
      ${enabled ? styles['header-container'] : styles['no-visible']} 
      `}
      style={zIndex ? { zIndex: zIndex } : {}}
      data-testid="header-container"
    >
      <div className={styles['content-alert']}>
        <div className={styles['left-content']}>
          {withBackButton && (
            <button className={styles['page-header-icon-container']} onClick={onBackButtonClick}>
              <FAIcon
                iconName="chevron-left"
                iconStyle={IconStyle.SOLID}
                theme={Theme.PURPLE}
                data-testid="chevron-left-test"
              />
            </button>
          )}
          <h4>{title}</h4>
        </div>
        {showAlert && (
          <div className={styles['header-alert']}>
            <AlertContainer alertType={alertType} onAlertClick={onAlertClick} />
          </div>
        )}
      </div>
      {/* <div className={styles['actions-container']}>
        {button.map((btn) => (
          <Button key={btn.title} size={ButtonSize.SMALL} {...btn} />
        ))}
      </div> */}
    </header>
  );
};

export default DashboardPageHeaderMobile;
export { PageHeaderType };
export type { PageHeaderProps };
